import { render } from "./BaseInputTip.vue?vue&type=template&id=e9c62e5e"
import script from "./BaseInputTip.vue?vue&type=script&lang=js"
export * from "./BaseInputTip.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-client/megaluzz-client/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__